import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { MyCoursesTabs } from 'routes/paths'
import styles from '../MyCourses.module.scss'

interface ITabButtons {
  activeTab: MyCoursesTabs
  onChangeTab: (tab: MyCoursesTabs) => void
}
export const TabButtons: React.FC<ITabButtons> = ({
  activeTab,
  onChangeTab,
}) => {
  const { t } = useTranslation()
  const containerRef = useRef<any>()

  const handleTabClick = (key: MyCoursesTabs, element: HTMLDivElement) => {
    onChangeTab(key)
    const targetElement = element
    const containerElement = containerRef.current
    if (containerElement && targetElement) {
      containerElement.scrollTo({
        left: targetElement.offsetLeft - 50,
        behavior: 'smooth',
      })
    }
  }

  return (
    <div
      id="TabsContainer"
      ref={containerRef}
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        whiteSpace: 'nowrap',
      }}
    >
      {[
        {
          title: t('home.lmsIndex.lmsMyCourses.tabs.byStatus'),
          key: MyCoursesTabs.status,
        },
        {
          title: t('home.lmsIndex.lmsMyCourses.tabs.byCategory'),
          key: MyCoursesTabs.categories,
        },
        {
          title: t('home.lmsIndex.lmsMyCourses.tabs.byProgram'),
          key: MyCoursesTabs.learningPaths,
        },
      ].map(({ title, key }) => (
        <div
          key={key}
          id={key}
          className={`${styles.coursesTab} ${
            activeTab === key ? styles.activeTab : ''
          }`}
          onClick={(e) => {
            handleTabClick(key, e.currentTarget)
          }}
        >
          {title}
        </div>
      ))}
    </div>
  )
}
